export default __webpack_public_path__ + "static/media/Armbands of the Ecliptic.6050ceb1.jpg";